window["fp_responsiveSlidesExtension"] = function () {
    var $this = this,
        utils = fp_utils,
        $ = fp_utils.$,
        fpdata = fullpage_api.getFullpageData(),
        options = fpdata.options,
        internals = fpdata.internals,
        ACTIVE = "active",
        ACTIVE_SEL = '.' + ACTIVE,
        SECTION = "fp-section",
        SECTION_SEL = '.' + SECTION,
        SECTION_ACTIVE_SEL = SECTION_SEL + ACTIVE_SEL,
        SLIDE = "fp-slide",
        SLIDE_SEL = '.' + SLIDE,
        CONTAINER_SEL = ".fp-slidesContainer",
        CONVERTED_SECTION = 'fp-converted-section',
        CONVERTED_SECTION_SEL = '.' + CONVERTED_SECTION,
        closest = utils.closest,
        addClass = utils.addClass,
        removeClass = utils.removeClass,
        hasClass = utils.hasClass,
        css = utils.css;

    function ifMenuEnabled() {
        return '#menu' === options.menu;
    }

    $this.toSections = function () {
        $(CONVERTED_SECTION_SEL).length ||
        ($(CONTAINER_SEL).forEach(function ($container) {
            var closestSection = closest($container, SECTION_SEL),
                bgColor = getComputedStyle(closestSection)['background-color'],
                slides = $(SLIDE_SEL, $container);

            if (ifMenuEnabled()) {

                $container.outerHTML = $container.innerHTML;

                if (options.anchors.length) {
                    slides.forEach(function (slide, i) {
                        if (i && null == slide.getAttribute("data-anchor") && ifMenuEnabled()) {
                            slide.setAttribute("data-anchor", closestSection.getAttribute('data-anchor') + (i + 1));
                        }
                    });
                }
            }

            hasClass(closestSection, ACTIVE) ||
            removeClass(slides, ACTIVE),
                slides.forEach(function (_slide, j) {
                    j ?
                        (
                            removeClass(_slide, SLIDE),
                            addClass(_slide, SECTION),
                            addClass(_slide, CONVERTED_SECTION)
                        ) :
                            css(_slide, {'width': "100%"}),
                    hasClass(closestSection, ACTIVE) && hasClass(_slide, ACTIVE) /*&& siteCheck()*/ && j &&
                    (
                        addClass(_slide, ACTIVE),
                        removeClass(closestSection, ACTIVE)
                    );
                }),
            utils.after(closestSection, $container),
            closestSection.innerHTML = '';
            //css(slides, {'background-color': bgColor});
        }),

        utils.remove($('.fp-controlArrow')),

        $(CONTAINER_SEL).forEach(function (cont) {
            cont.outerHTML = cont.innerHTML;
        }),
        css($(CONVERTED_SECTION_SEL), {'width': ''}),

        $(SECTION_SEL + ":not(" + CONVERTED_SECTION_SEL + ')').forEach(function (_section) {
            var nextSection = utils.next(_section, SLIDE_SEL);
            null != nextSection &&
                utils.appendTo(nextSection, _section);
            var _slides = $(SLIDE_SEL, _section);
            _slides.length &&
                internals.styleSlides(_section, _slides, _slides.length);
        }),
        $this.scrollToActive($(SECTION_ACTIVE_SEL)[0]));
    },

    $this.scrollToActive = function (el) {
        var offsetTop = el.offsetTop;

        if (options.autoScrolling && !options.scrollBar) {
            internals.silentScroll(offsetTop);
        } else {
            internals.silentScroll(0);
            window.scrollTo(0, offsetTop);
        }
    },

    $this.toSlides = function () {
        if ($(CONVERTED_SECTION_SEL).length) {
            $(SECTION_SEL + ":not(" + CONVERTED_SECTION_SEL + ')').forEach(function (_sectionConverted) {
                var _firstSectionConverted = $(CONTAINER_SEL, _sectionConverted)[0];
                if (null != _firstSectionConverted) {
                    var _parent = _firstSectionConverted.parentNode;
                    _firstSectionConverted.outerHTML = _firstSectionConverted.innerHTML;
                    _parent.outerHTML = _parent.innerHTML;
                }
            });
            var firstActiveSection = $(SECTION_ACTIVE_SEL)[0];
            hasClass(firstActiveSection, CONVERTED_SECTION),

            $(CONVERTED_SECTION_SEL).forEach(function (_sectionConverted) {
                var _prevSectionConverted = utils.prev(_sectionConverted);

                hasClass(_sectionConverted, ACTIVE) &&
                    (
                        addClass(_prevSectionConverted, ACTIVE),
                        removeClass($(SLIDE_SEL + ACTIVE_SEL, _prevSectionConverted), ACTIVE)
                    );

                ifMenuEnabled() &&
                    (
                        removeClass(_sectionConverted, SECTION),
                        removeClass(_sectionConverted, CONVERTED_SECTION),
                        addClass(_sectionConverted, SLIDE),
                        css(_sectionConverted, {'background-color': ''}),
                        utils.appendTo(_sectionConverted, _prevSectionConverted)
                    );
            }),

            $(SECTION_SEL).forEach(function (_section) {
                var _slide = $(SLIDE_SEL, _section);
                if (_slide.length) {
                    internals.styleSlides(_section, _slide, _slide.length);
                }
            });

            $this.scrollToActive($(SECTION_ACTIVE_SEL)[0]);

            internals.keepSlidesPosition();
        }
    };

    return $this;
};